import { useState } from "react";
import { Lock } from "lucide-react";
import { api, setToken, errMsg } from "@/lib/api";

export const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      onLogin(data.user);
    } catch (err) {
      setError(errMsg(err, "Could not sign in."));
    } finally { setBusy(false); }
  };

  return (
    <div className="lg lg-login">
      <form className="lg-card lg-fade" onSubmit={submit} data-testid="deck-login-form">
        <div className="lg-eyebrow"><Lock size={12} style={{ display: "inline", marginRight: 6 }} />Leaders only</div>
        <h1 style={{ fontSize: 28, margin: "10px 0 6px" }}>Command Deck</h1>
        <p className="lg-lead" style={{ marginBottom: 22, fontSize: 14 }}>Sign in to edit the roster, brackets, plans and intake.</p>
        <div className="lg-field" style={{ marginBottom: 14 }}>
          <label htmlFor="em">Email</label>
          <input id="em" className="lg-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="deck-login-email" />
        </div>
        <div className="lg-field" style={{ marginBottom: 18 }}>
          <label htmlFor="pw">Password</label>
          <input id="pw" className="lg-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="deck-login-password" />
        </div>
        {error && <p className="lg-err" style={{ marginBottom: 14 }} data-testid="deck-login-error">{error}</p>}
        <button className="lg-btn" style={{ width: "100%" }} disabled={busy} data-testid="deck-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
        <div className="lg-foot"><a href="/" data-testid="deck-login-member-link">Member preview</a><a href="/join" data-testid="deck-login-join-link">Enlist page</a></div>
      </form>
    </div>
  );
};
